export const SETTLEMENT_WITHHOLDING_RATE = 0.033;

const won = (value: number) => Math.max(0, Math.round(Number(value) || 0));

export const netSettlementAmount = (grossAmount: number) =>
  Math.round(won(grossAmount) * (1 - SETTLEMENT_WITHHOLDING_RATE));

/** 별도로 등록한 조정 항목만 정산 합계의 공제·추가에 반영한다. */
export const settlementAdjustmentAmounts = (record: { adjustmentKind: "deduction" | "addition" | null; adjustmentAmount: number }) => ({
  deductionAmount: record.adjustmentKind === "deduction" ? won(record.adjustmentAmount) : 0,
  additionAmount: record.adjustmentKind === "addition" ? won(record.adjustmentAmount) : 0,
});

/**
 * Legacy teddify-managing settlement policy:
 * 1. add every gross compensation for a worker,
 * 2. subtract pre-tax deductions and add pre-tax additions once,
 * 3. withhold 3.3% from the resulting taxable gross, rounded to won.
 */
export const calculateSettlementAmounts = (
  grossAmount: number,
  deductionAmount = 0,
  additionAmount = 0,
) => {
  const gross = won(grossAmount);
  const deduction = won(deductionAmount);
  const addition = won(additionAmount);
  const taxableGrossAmount = Math.max(0, gross - deduction + addition);
  const payableAmount = netSettlementAmount(taxableGrossAmount);
  return {
    grossAmount: gross,
    deductionAmount: deduction,
    additionAmount: addition,
    taxableGrossAmount,
    withholdingAmount: taxableGrossAmount - payableAmount,
    payableAmount,
  };
};

/** 수동 정산액은 세금 계산 뒤 이체액에 더합니다. 작업자별 음수 이체는 0원으로 제한합니다. */
export const calculateWorkerPayable = (gross: number, deduction: number, addition: number, manualAmount = 0) =>
  Math.max(0, calculateSettlementAmounts(gross, deduction, addition).payableAmount + manualAmount);
